
import { ulid } from 'ulid';

export function generateULID():ID {

    return ulid();

}


/*


4. Monotonic ULIDs (better for high-frequency generation)

Ensures ordering even within the same millisecond.

import { monotonicFactory } from 'ulid';

const ulidFactory = monotonicFactory();

const id1 = ulidFactory();
const id2 = ulidFactory(); // guaranteed > id1

 */